export default __webpack_public_path__ + "static/media/Group8871.00b7ef40.svg";